import { StoreContext } from 'store';
import Cookies from 'js-cookie';

const UseAPI = async (signal, url, method, payload, includeCredentials = true, customHeaders = {}) => {
  // Retrieve the token from local storage
  const token = localStorage.getItem('user-token');
  const workspaceUuid = localStorage.getItem('current_workspace_uuid');

  const csrfToken = Cookies.get('csrftoken');

  try {
    let headers = {
      Authorization: `Token ${token}`,
      'X-CSRFToken': csrfToken,
      ...(workspaceUuid ? { 'X-Workspace-UUID': workspaceUuid } : {}),
      ...customHeaders, // Merge custom headers
    };

    let body;

    if (payload instanceof FormData) {
      // Let browser set Content-Type with boundary
      body = payload;
    } else {
      headers['Content-Type'] = 'application/json';
      body = JSON.stringify(payload);
    }

    let options = {
      method: method,
      headers: headers,
      body: body,
      signal,
      credentials: includeCredentials ? 'include' : 'same-origin',
    };

    if (method === 'GET') {
      options = {
        method: method,
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Token ${token}`,
          'X-CSRFToken': csrfToken,
          ...(workspaceUuid ? { 'X-Workspace-UUID': workspaceUuid } : {}),
          ...customHeaders, // Merge custom headers for GET
        },
        signal,
        credentials: includeCredentials ? 'include' : 'same-origin',
      };
    }

    const response = await fetch(url, options);

    if (!response.ok) {
      if (response.status === 401) {
        // setIsLoggedIn(false);
        // navigate('/login');
        localStorage.clear();
        const result = { httpStatusCode: 401, code: 401, message: 'Unauthorized' };
        return result;
      } else if (response.status === 500 || response.status === 502) {
        const result = {
          httpStatusCode: response.status,
          code: response.status,
          message: 'Server error',
        };
        return result;
      } else {
        // Parse response body to get detailed error info (e.g. LIMIT_REACHED code, message, etc.)
        let errorData = {};
        try {
          errorData = await response.json();
        } catch (e) {
          // Response body is not JSON, ignore
        }
        const result = {
          httpStatusCode: response.status,
          code: errorData.code || response.status,
          message: errorData.error || errorData.message || 'Invalid request',
          ...errorData,
        };
        return result;
      }
    }

    if (response.status === 204) {
      const result = { httpStatusCode: 204, code: 200, message: 'Deleted' };
      return result;
    } else {
      const result = await response.json();
      return result;
    }
  } catch (error) {
    //window.location.reload();
    console.error('Error fetching data:', error);
    throw error;
  }
};

export default UseAPI;

